export default __webpack_public_path__ + "static/media/practica-sanitaria.3a6c212e.svg";